import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import i18n from '@/utils/i18n';
import React, { useEffect } from 'react';
import { BOTTOM_NAV_BAR_REVEAL_TIMING_CONFIG } from '@experiences/blocs/utils/animations';
import { Chip, Icons, XStack } from '@usepepper/sprout-kit-ui';
import { createStyles } from '@/contexts/theme-context';
import { useKeyboardState } from 'react-native-keyboard-controller';

const HIDDEN_SCALE = 0.4;

interface OrderEntryMobileSearchPillProps {
  isVisible: boolean;
  onPress: () => void;
}

export const OrderEntryMobileSearchPill: React.FC<
  OrderEntryMobileSearchPillProps
> = ({ isVisible, onPress }) => {
  const [styles] = useStyles();
  const isKeyboardVisible = useKeyboardState((state) => state.isVisible);
  const isShown = isVisible && !isKeyboardVisible;

  const progress = useSharedValue(isShown ? 1 : 0);
  useEffect(() => {
    progress.value = withTiming(
      isShown ? 1 : 0,
      BOTTOM_NAV_BAR_REVEAL_TIMING_CONFIG,
    );
  }, [isShown, progress]);
  const showHideStyle = useAnimatedStyle(() => ({
    opacity: progress.value,
    transform: [{ scale: HIDDEN_SCALE + (1 - HIDDEN_SCALE) * progress.value }],
  }));

  return (
    <XStack
      justifyContent="center"
      marginBottom="$8"
      pointerEvents={isShown ? 'box-none' : 'none'}
    >
      <Animated.View style={showHideStyle}>
        <Chip
          accessibilityElementsHidden={!isShown}
          aria-hidden={!isShown}
          aria-label={i18n.t('search')}
          backgroundColor="$bgSecondaryDefault"
          circular
          importantForAccessibility={isShown ? 'auto' : 'no-hide-descendants'}
          onPress={onPress}
          pressable
          size="$md"
          style={styles.pillPadding}
          tabIndex={isShown ? 0 : -1}
        >
          <Chip.Icon>
            <Icons.Search />
          </Chip.Icon>
          <Chip.Text>{i18n.t('search')}</Chip.Text>
        </Chip>
      </Animated.View>
    </XStack>
  );
};

const useStyles = createStyles((theme) => ({
  pillPadding: {
    paddingLeft: theme.sk.spacing.spaceMedium,
    paddingRight: theme.sk.spacing.spaceMedium,
  },
}));
